export default __webpack_public_path__ + "static/Gilroy-Regular-a2fa27187669beec8df9bbee15000caa.woff2";